export default __webpack_public_path__ + "static/logo Beka-98546d74be1c41556659f757db598ea8.jpg";